import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { ncFileDetailsPartConfig } from './config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const NCFileDetailsPartStack = createStackNavigator();

const NCFileDetailsPartNavigator = () => {
  return (
    <NCFileDetailsPartStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {ncFileDetailsPartConfig.map(({ Component, name }) => (
        <NCFileDetailsPartStack.Screen key={name} name={name} component={Component} />
      ))}
    </NCFileDetailsPartStack.Navigator>
  );
};

export { NCFileDetailsPartNavigator };
